module.exports = __webpack_public_path__ + "static/img/team-color-1.140ef59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/team-color-1.png
// module id = z9TB
// module chunks = 9